var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.$bem(),on:{"click":_vm.onClick}},[_vm._v(" Поділитися "),_c('img',{attrs:{"src":_vm.shareIcon,"alt":"share icon"}})])}
var staticRenderFns = []

export { render, staticRenderFns }